import React, { useState, useEffect, useCallback } from "react";

// componments
import { FormSidebar } from "../_commons/FormSidebar";
import { CopyToClipboard } from "../_commons/CopyToClipboard";

// third party
import moment from "moment";

// utils
import { capitaliseTextStrict } from "../../atlas-utils";

// constants
import { ACTION_RENDER_TEXT_MAP } from "./Logs";
import ExplainWithAI from "../ExplainWithAI/ExplainWithAI";

const LogErrorReport = ({ isOpen, close, data = {} }) => {
	const [loading, setLoading] = useState(true);
	const [copyReportBtn, setCopyReportBtn] = useState(false);
	const [report, setReport] = useState(null);

	const handleData = useCallback(async () => {
		// reset state if closed
		if (!isOpen) {
			setTimeout(() => {
				setReport(null);
				setLoading(true);
			}, 100);
			return;
		}

		if (!data?.resultUrl) {
			setLoading(false);
			return;
		}

		setLoading(true);
		try {
			const resp = await fetch(data?.resultUrl);
			const parsedResp = await resp.json();
			setReport(parsedResp);
		} catch (error) {
			console.log(error);
		}
		setLoading(false);
	}, [isOpen, data]);

	useEffect(() => {
		handleData();
	}, [handleData]);

	const handleClose = useCallback(() => {
		close();
	}, [close]);

	const renderSubTitle = () => {
		return (
			<div>
				View error report of <b>{data?.platformName}</b> for <b>{data?.locationPlatform?.location?.name}</b> for{" "}
				<b>
					{capitaliseTextStrict(
						ACTION_RENDER_TEXT_MAP[data?.action?.toLowerCase()] || data?.action?.toLowerCase(),
						true
					)}
				</b>{" "}
				action, requested on <b>{moment(data?.updated).format("DD MMM, YYYY")}</b> at{" "}
				<b>{moment(data?.updated).format("hh:mm A")}</b>
			</div>
		);
	};

	return (
		<div className="log-error-report">
			<FormSidebar
				isOpen={isOpen}
				close={handleClose}
				title={"Error Report"}
				subTitle={renderSubTitle()}
				hideActions={true}
				isNested={true}
			>
				{!loading && data?.result && (
					<div className="report-details">
						{data?.result && <ExplainWithAI payload={JSON.parse(data?.result)} src="error-log-report" />}
						<div
							className="json-container report"
							onMouseEnter={() => setCopyReportBtn(true)}
							onMouseLeave={() => setCopyReportBtn(false)}
						>
							{copyReportBtn && <CopyToClipboard content={data?.result || ""} showIcon={true} />}
							{data?.result && <pre>{JSON.stringify(JSON.parse(data?.result), null, 4)}</pre>}
						</div>
					</div>
				)}
				{!loading && report && (
					<div className="report-details">
						{report && <ExplainWithAI payload={report} />}
						<div
							className="json-container report"
							onMouseEnter={() => setCopyReportBtn(true)}
							onMouseLeave={() => setCopyReportBtn(false)}
						>
							{copyReportBtn && <CopyToClipboard content={report || ""} showIcon={true} />}
							{report && <pre>{JSON.stringify(report, null, 4)}</pre>}
						</div>
					</div>
				)}
				{loading && (
					<div className="P(10px)">
						<div className="shimmer H(60px) Mb(10px)" />
						<div className="shimmer H(60px) Mb(10px)" />
					</div>
				)}
				{!loading && !data?.result && !report && (
					<div className="no-items-placeholder">No error report found!</div>
				)}
			</FormSidebar>
		</div>
	);
};
export default LogErrorReport;
